export default __webpack_public_path__ + "static/media/Sinergia_BannerRegistro_movil.ddb63464.jpg";